import React from "react"
import { Skeleton } from "@material-ui/lab"
import { Grid, makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	skeleton: {
		transform: "scale(1)"
	}
})

const ScheduledSnoozeContentSkeleton = () => {
	const classes = useStyles()

	return (
		<Grid container spacing={2} style={{ width: "400px" }}>
			<Grid item xs={12}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<Skeleton variant="text" className={classes.skeleton} width={100} height={20} />
							</Grid>
							<Grid item xs={12}>
								<Skeleton variant="rect" className={classes.skeleton} width="100%" height={60} />
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<Skeleton variant="text" className={classes.skeleton} width={100} height={20} />
							</Grid>
							<Grid item xs={12}>
								<Skeleton className={classes.skeleton} width="100%" height={180} />
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default ScheduledSnoozeContentSkeleton
